import moment from 'moment';
import 'moment/locale/es-mx'; // Importa el idioma español para México


const formatoModena = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
});

//const opcionesFecha = { timeZone: 'America/Mexico_City',weekday: "long", year: "numeric", month: "long", day: "numeric",hour: "numeric",minute:"numeric",second:"numeric", hour12:"false" };
const opcionesFecha = { timeZone: 'America/Mexico_City',weekday: "long", year: "numeric", month: "long", day: "numeric", hour12:"false" };
const opcionesFechaHora = { timeZone: 'America/Mexico_City',weekday: "long", year: "numeric", month: "long", day: "numeric", hour: "numeric",minute:"numeric",second:"numeric",hour12:"true" };

const servicioFormatos = {

    formatearModena(valor) {
       return formatoModena.format(valor);
    },

    formatearFecha(valor) {        
        let fecha  = new Date(valor);
        return fecha.toLocaleString('es-MX',opcionesFecha);
    },
    formatearFechaHora(valor) {        
        let fecha  = new Date(valor);
        return fecha.toLocaleString('es-MX',opcionesFechaHora);
    },
    formatoFechaMilisegundosMoment(valor){
        const fecha = moment(valor);
        return fecha.format('LL');
    }

    
}

export default servicioFormatos;